export const StatusCheckmarkIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#6EBA7F"/>
            <path d="M8 12L10.5 14.5L16 9" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}; 